/* global FormData */
import OButton from 'components/reusable/OButton'
import useToastContext from 'hooks/useToastContext'
import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { apiPost, apiGet } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import { useTranslation } from 'react-i18next'
import OInputField from 'components/reusable/OInputField'
import OSelect from 'components/reusable/OSelect'

const AddTopMenu = ({ setShowModal, allTopMenus }) => {
  const { t } = useTranslation()
  const {
    register,
    handleSubmit,
    formState: { errors, isDirty }
  } = useForm({
    mode: 'onChange',
    shouldFocusError: true
  })
  const notification = useToastContext()
  const [addMerchantLoading, setAddMerchantLoading] = useState(false)
  const [parentList, setParentList] = useState([{ value: '', key: 'Make this a Parent' }])

  useEffect(() => {
    const fetchParents = async () => {
      try {
        const result = await apiGet(apiPath.ListTopMenus, { pageSize: 1000 })
        if (result?.data?.success) {
          const formatted = result.data.results.docs.map(i => ({ value: i._id, key: i.name }))
          setParentList([{ value: '', key: 'Make this a Parent' }, ...formatted])
        }
      } catch (error) {
        console.error('Error fetching parent menus', error)
      }
    }
    fetchParents()
  }, [])

  const onSubmit = async data => {
    setAddMerchantLoading(true)
    try {
      if (data.parentId === '') {
        data.parentId = null
      }
      const path = apiPath.ListTopMenus
      const result = await apiPost(path, { ...data })
      if (result?.data?.success) {
        allTopMenus()
        setShowModal(false)
        notification.success(result.data.message)
      } else {
        notification.error(result.data.message)
      }
      
    } catch (error) {
      console.error('error in get all menus list==>>>>', error.message)
    }
    setAddMerchantLoading(false)
  }
  
const menuTypeList = [
    {"value": "Customer" , "key": "Customer"},
    {"value": "Agent", "key": "Agent" },
    {"value" : "Company" , "key" : "Company" },
    {"value" : "website" , "key" : "Website" }
]
  return (
    <>
      <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
        <div className='relative my-6  w-full max-w-[750px] mx-auto'>
          <div className='sm:py-4 sm:px-2 py-8 px-7 '>
            <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none'>
              <div className='flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t'>
                <h3 className='text-xl font-semibold'>{"Add Top Bar Menus"}</h3>
                <button
                  className=' ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none'
                  onClick={() => setShowModal(false)}
                >
                  <span className=' text-[#B8BBBF]  text-4xl ' title='Close'>
                    ×
                  </span>
                </button>
              </div>

              <div className='relative p-6 flex-auto'>
                <div className='grid grid-cols-1 sm:grid-cols-2 gap-4'>
                  <div className='px-2'>
                    <OSelect
                      wrapperClassName='relative z-0 w-full group m-auto'
                      name='parentId'
                      inputLabel={
                        <>
                          {t('PARENT_MENU')}
                        </>
                      }
                      type='select'
                      options={parentList}
                      defaultValue={t('SELECT_PARENT_MENU')}
                      register={register('parentId')}
                      errors={errors}
                    />
                  </div>
                  <div className='px-2'>
                      <OSelect
                          wrapperClassName='relative z-0 w-full group m-auto'
                          name='menuType'
                          inputLabel={
                            <>
                              {t('O_TOP_MENU_TYPE')}
                              <span className='text-red-500'>*</span>
                            </>
                          }
                          type='select'
                          options={menuTypeList}
                          defaultValue={t('O_SELECT_TOP_MENU_TYPE')}
                          register={register(
                            'menuType',{
                              required: 'Type  is required.',
                              validate: value => {
                                return value.trim() ? true : 'White spaces not allowed.'
                              }
                            },
                          )}
                          errors={errors}
                        />
                  </div>
                  <div className='px-2'>
                    <OInputField
                      wrapperClassName='relative z-0 w-full group m-auto'
                      name='name'
                      inputLabel={
                        <>
                          {t('O_NAME')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      type='text'
                      autoFocus
                      // maxLength={15}
                      register={register('name', {
                        required: 'Name is required.',
                        minLength: {
                          value: 2,
                          message: 'Minimum length must be 2.'
                        },
                        validate: value => {
                          return value.trim()
                            ? true
                            : 'White spaces not allowed.'
                        }
                      })}
                      errors={errors}
                    />
                  </div>

                  <div className='px-2'>
                    <OInputField
                      wrapperClassName='relative z-0 w-full group m-auto'
                      name='nameAr'
                      inputLabel={
                        <>
                          {t('O_NAME') + t('O_ARABIC')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      type='text'
                      // maxLength={15}
                      register={register('nameAr', {
                        required: 'Name in arabic is required.',
                        minLength: {
                          value: 2,
                          message: 'Minimum length must be 2.'
                        },
                        validate: value => {
                          return value.trim() ? true : 'White spaces not allowed.'
                        }
                      })}
                      errors={errors}
                    />
                  </div>

                  <div className='px-2'>
                    <OInputField
                      wrapperClassName='relative z-0 w-full group m-auto'
                      name='link'
                      inputLabel={
                        <>
                          {t('O_MENU_LINK')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      type='text'
                      // maxLength={15}
                      register={register('link', {
                        required: 'Link is required.',
                        minLength: {
                          value: 1,
                          message: 'Minimum length must be 2.'
                        },
                        validate: value => {
                          return value.trim()
                            ? true
                            : 'Enter valid url.'
                        }
                      })}
                      errors={errors}
                    />
                  </div>


                  <div className='px-2'>
                    <OInputField
                      wrapperClassName='relative z-0 w-full group m-auto'
                      name='linkAr'
                      inputLabel={
                        <>
                          {t('O_MENU_LINK_AR')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      type='text'
                      // maxLength={15}
                      register={register('linkAr', {
                        required: 'Link is required.',
                        minLength: {
                          value: 1,
                          message: 'Minimum length must be 2.'
                        },
                        validate: value => {
                          return value.trim()
                            ? true
                            : 'Enter valid url.'
                        }
                      })}
                      errors={errors}
                    />
                  </div>

                  <div className='px-2'>
                    <OInputField
                      wrapperClassName='relative z-0 w-full group m-auto'
                      name='menuOrder'
                      inputLabel={
                        <>
                          {t('O_MENU_ORDER')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      type='text'
                      // maxLength={15}
                      register={register('menuOrder', {
                        required: 'order is required.',
                        validate: value => {
                          const numericRegex = /^[0-9]+$/;
                          return numericRegex.test(value)
                            ? true
                            : 'Enter valid number.'
                        }
                      })}
                      errors={errors}
                    />
                  </div>
                  <div className='px-2 mt-5'>
                    <div className='relative z-0 w-full group m-auto flex items-center h-full'>
                      <input
                        type='checkbox'
                        id='highlightfield'
                        className='w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500'
                        {...register('highlightfield')}
                      />
                      <label htmlFor='highlightfield' className='ml-2 text-sm font-medium text-gray-900'>
                        {t('HIGHLIGHT_FIELD', 'Highlight Field (Animation)')}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className='flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b'>
                <button
                  className='text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150'
                  type='button'
                  onClick={() => setShowModal(false)}
                >
                  {t('O_BACK')}
                </button>
                {addMerchantLoading ? (
                  <div className='spinner-container'>
                    {' '}
                    <div className='loading-spinner' />
                  </div>
                ) : (
                  <OButton
                    disabled={!isDirty}
                    label={<>{t('O_ADD')}</>}
                    type='submit'
                    onClick={handleSubmit(onSubmit)}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='opacity-25 fixed inset-0 z-40 bg-black' />
    </>
  )
}

export default AddTopMenu
